import { getFileExtension } from "@/modern/utils";
import { FormattedFile } from "@/react/components/entityViews/files/context/EntityFileContext";

export interface SpotIncentiveFileData {
  fileId?: number | string;
  documentId?: number;
  file?: File;
  fileName?: string;
}

/**
 * Converts a blob URL to a File object
 */
async function blobUrlToFile(blobUrl: string, filename: string): Promise<File> {
  const response = await fetch(blobUrl);
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type });
}

/**
 * Prepares file data for the SpotIncentive editor
 * - For BoardFiles: returns fileId to reference existing file
 * - For CompanyCam images: converts blob to File for upload
 */
export async function prepareFileForSpotIncentive(
  file: FormattedFile
): Promise<SpotIncentiveFileData | null> {
  try {
    // If it's a BoardFile with an ID, use that
    if (file.record && file.record.id) {
      return {
        fileId: file.record.id
      };
    }

    // If it's a CompanyCam image with originalImageUrl, convert blob to File
    if (file.isCCImage && file.originalImageUrl) {
      const fileNameWithExtension = `${file.name}.${getFileExtension(file.originalImageUrl)}`;
      const imageFile = await blobUrlToFile(file.originalImageUrl, fileNameWithExtension);
      return {
        file: imageFile,
        fileName: fileNameWithExtension
      };
    }

    return null;
  } catch (error) {
    console.error("Error preparing file for spot point:", error);
    return null;
  }
}
